export default "__VITE_ASSET__Cu7YZ2Le__"